import { Flex, Tooltip, theme } from "antd"
import styles from "./index.module.css"
import PropTypes from "prop-types"
import BookingConflictWarning from "pagesV2/pro/Calendar/Tooltips/BookingConflictWarning"
import { getEventColor } from "pagesV2/pro/Calendar/utils"
import { getEventPreviewColors, getDefaultCalendarColor, getPrimaryCalendarTextColor } from "pagesV2/pro/Calendar/calendarColorUtils"
import { useTheme } from "context/AntdThemeContext"

const { useToken } = theme

const EventBlock = ({
  event,
  eventColor,
  conflict,
  setIsBookingModalOpen,
  setSelectedBookingId,
  fullHeight,
  multipleInSlot,
  compact,
  hideTime
}) => {
  const { id, startLabel, endLabel, title } = event || {}
  const { token } = useToken()
  const { theme } = useTheme()

  const handleClick = () => {
    setIsBookingModalOpen(true)
    setSelectedBookingId(event?.id)
  }

  const timeRange = startLabel && endLabel ? `${startLabel} – ${endLabel}` : null
  const tooltipTitle = [timeRange, title].filter(Boolean).join("\n")

  let timeClassName = styles.eventTime
  if (compact) timeClassName = styles.eventTimeCompact
  else if (multipleInSlot) timeClassName = styles.eventTimeWrap

  let titleClassName = styles.eventTitle
  if (compact) titleClassName = styles.eventTitleCompact
  else if (multipleInSlot) titleClassName = styles.eventTitleWrap

  const actualColor = event?.color || eventColor
  const resolvedColor = getEventColor(actualColor)
  const isCustomColor = resolvedColor?.startsWith("#")
  const primaryTextColor = getPrimaryCalendarTextColor(theme)
  const defaultColor = getDefaultCalendarColor()
  const previewColors = isCustomColor
    ? getEventPreviewColors(resolvedColor, defaultColor, primaryTextColor)
    : {
        backgroundColor: resolvedColor,
        borderColor: primaryTextColor,
        textColor: primaryTextColor
      }
  const blockClassName = compact ? `${styles.eventBlock} ${styles.eventBlockCompact}` : styles.eventBlock

  return (
    <Tooltip title={tooltipTitle} mouseEnterDelay={0.5}>
      <button
        type="button"
        key={id || title + startLabel + endLabel}
        className={blockClassName}
        style={{
          backgroundColor: previewColors.backgroundColor,
          borderColor: previewColors.borderColor,
          ...(fullHeight ? { height: "100%" } : {}),
          ...(multipleInSlot ? { whiteSpace: "normal", wordBreak: "break-word" } : {})
        }}
        onClick={handleClick}
      >
        {!hideTime && (
          <Flex align="center" justify="space-between" gap={compact ? 2 : 4}>
            <span className={timeClassName} style={{ color: previewColors.textColor || primaryTextColor }}>
              {startLabel} - {endLabel}
            </span>
            {conflict ? <BookingConflictWarning /> : null}
          </Flex>
        )}

        <span className={titleClassName} style={{ color: previewColors.textColor || primaryTextColor }}>
          {title}
        </span>
      </button>
    </Tooltip>
  )
}

EventBlock.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    startLabel: PropTypes.string,
    endLabel: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string
  }),
  eventColor: PropTypes.string,
  setIsBookingModalOpen: PropTypes.func,
  setSelectedBookingId: PropTypes.func,
  conflict: PropTypes.bool,
  fullHeight: PropTypes.bool,
  multipleInSlot: PropTypes.bool,
  compact: PropTypes.bool,
  hideTime: PropTypes.bool
}

export default EventBlock
